import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        events: '=',
        allEvents: '=',
        type: '=',
        counts: '=',
        filter: '=',
        classifiers: '=',
        applyFilter: '&'
    },
    template: `
        <div class="form form-filter form-filter-vertical">
            <div class="heading01">
                <div class="row row-full mt0">
                    <div class="items">
                        <ul class="checkboxes04">
                            <li>
                                <label>
                                    <input type="radio" name="r01" checked ng-click="vm.type='all';vm.filterEventsByType()">
                                    <span>{{ 'dashboard.All' | translate }} ({{ vm.counts.all }})</span>
                                </label>
                            </li>
                            <li ng-repeat="(key,value) in vm.filteredLabels">
                                <label>
                                    <input type="radio" name="r01" ng-click="vm.type=key;vm.filterEventsByType()">
                                    <span>{{ value }} ({{ vm.counts[key] }})</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="fields">
                <div class="row row-full">
                    <label class="label">{{ 'filter.Course' | translate }}</label>
                    <div class="items">
                        <input ng-model="vm.filter.course" type="text" class="form-control"
                        ng-keyup="vm.handleKey($event.keyCode)"
                        ng-blur="vm.applyFilter()">
                    </div>
                </div>
                <div class="row row-full">
                    <label class="label">{{ 'filter.Department' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.departmentId" ng-change="vm.applyFilter()"
                        ng-options="item.id as item.value for item in vm.departments">
                        <option value="">{{ 'course.All departments' | translate }}</option>
                    </select>
                    </div>
                </div>
                <div class="row row-full">
                    <label class="label">{{ 'filter.Role' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.roleId" ng-change="vm.applyFilter()"
                            ng-options="item.id as item.value for item in vm.roles">
                        <option value="">{{ 'course.All roles' | translate }}</option>
                    </select>
                    </div>
                </div>
                <div class="row row-full">
                    <label class="label">{{ 'filter.Level' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.levelId" ng-change="vm.applyFilter()"
                            ng-options="item.id as item.value for item in vm.levels">
                        <option value="">{{ 'course.All levels' | translate }}</option>
                    </select>
                    </div>
                </div>
                <div class="row row-full">
                    <label class="label">{{ 'filter.Trainer/Training Company' | translate }}</label>
                    <div class="items">
                        <input
                            ng-model="vm.trainerSearch"
                            type="text"
                            class="form-control"
                            ng-keyup="vm.handleKey($event.keyCode)"
                            ng-blur="vm.applyFilter()"
                        >
                    </div>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor (lodash, COURSE_TRAINING_TYPE_ENUM, CLASSIFIER_ENUM) {
        this.lodash = lodash;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.departments = this.classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
    }

    $onInit () {
        this.trainerSearch = null;
        const keysToKeep = ['CLASSROOM', 'WEBINAR'];
        this.filteredLabels = Object.fromEntries(
            Object.entries(this.COURSE_TRAINING_TYPE_ENUM.LABELS).filter(([key]) => keysToKeep.includes(key))
        );
    }

    filterEventsByType () {
        this.events = this.type === 'all' ? this.allEvents : this.allEvents.filter((event) => event.type === this.type);
    }

    handleKey (key) {
        this.filter = this.lodash.assign(this.filter, { trainerSearch: this.trainerSearch });
        // 13 is ENTER key
        if (key === 13) {
            this.applyFilter();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/schedule/filter/index.js